import {
  goToProfileVerifyAccount
} from 'shared/auth/actions';

export const handleResendEmailClick = () => (dispatch) => { 
  dispatch(goToProfileVerifyAccount()); 
};



// WEBPACK FOOTER //
// ./src/features/registration/accountCreated/actions.js